export const landingPage = 'Landing Page';
